module.exports = __webpack_public_path__ + "img/development-document-429621c0.png";